import React, {useEffect} from 'react';
import {useNavigate, Outlet} from 'react-router-dom';
import { isLoggedIn } from 'utils/auth';

interface AuthGuardProps {
    children?: React.ReactNode;
    redirectTo?: string;
}

export function AuthGuard({children, redirectTo = '/login'}: AuthGuardProps) {
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn()) {
            navigate(redirectTo);
        }
    }, [navigate, redirectTo]);

    return children ? <>{children}</> : <Outlet/>;
} 